<template>
  <v-card>
    <v-card-text>
      <v-text-field label="URL" v-model="url"></v-text-field>
      <v-textarea label="Description" v-model="description"></v-textarea>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    data: Object,
    index: Number
  },
  data() {
    return {
      url: "",
      description: "",
      first: -2
    };
  },
  mounted() {
    this.url = this.data.url?this.data.url:'';
    this.description = this.data.description?this.data.description:'';
  },
  watch: {
    url: function(val) {
      this.update({
        url: val,
        description: this.description
      });
    },
    description: function(val) {
      this.update({
        url: this.url,
        description: val
      });
    }
  },
  methods: {
    update: function(val) {
      if (this.first<0) {
        this.first++;
      } else {
        this.$emit("change", val);
      }
    }
  }
};
</script>
